export const REQUEST_ALL_FEATURES = "features/REQUEST_ALL_FEATURES";

export const ALL_FEATURES_IS_LOADING = "features/ALL_FEATURES_IS_LOADING";

export const REQUEST_ALL_FEATURES_SUCCESS =
  "features/REQUEST_ALL_FEATURES_SUCCESS";
export const REQUEST_ALL_FEATURES_FAIL = "features/REQUEST_ALL_FEATURES_FAIL";

export const SELECT_FEATURE_BY_ID = "features/SELECT_FEATURE_BY_ID";

export const RESET_SELECTED_FEATURE = "features/RESET_SELECTED_FEATURE";

export const SELECT_FEATURE_BOOKING_BY_ID =
  "features/SELECT_FEATURE_BOOKING_BY_ID";

export const RESET_FEATURE_BOOKING = "features/RESET_FEATURE_BOOKING";

// dat09
export const SELECT_FEATURE = "features/SELECT_FEATURE";
export const RESET_ALL_FEATURE = "features/RESET_ALL_FEATURE";
